import React from 'react';
import {
    Grid,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Slider,
    Box
} from '@mui/material';
import LocationSelector from '../../common/LocationSelector';

function PreferencesForm({ data, onChange }) {
    const handleChange = (field, value) => {
        onChange({
            ...data,
            profile: {
                ...data.profile,
                [field]: value
            }
        });
    };

    const handlePreferenceChange = (field, value) => {
        onChange({
            ...data,
            profile: {
                ...data.profile,
                preferences: {
                    ...data.profile.preferences,
                    [field]: value
                }
            }
        });
    };

    const handleLocationChange = (index, locationData) => {
        const newAreas = [...(data.profile.preferences.preferredAreas || [])];
        newAreas[index] = {
            ...newAreas[index],
            prefecture: locationData.prefecture?.name || '',
            city: locationData.city?.name || '',
            line: locationData.line?.name || '',
            station: locationData.station?.name || ''
        };
        handlePreferenceChange('preferredAreas', newAreas);
    };

    const handleRentRangeChange = (event, newValue) => {
        handlePreferenceChange('rentRange', {
            min: newValue[0],
            max: newValue[1]
        });
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Typography gutterBottom>希望家賃範囲</Typography>
                <Box sx={{ px: 2 }}>
                    <Slider
                        value={[
                            data.profile.preferences.rentRange.min,
                            data.profile.preferences.rentRange.max
                        ]}
                        onChange={handleRentRangeChange}
                        valueLabelDisplay="on"
                        min={0}
                        max={200000}
                        step={5000}
                        valueLabelFormat={(value) => `¥${value.toLocaleString()}`}
                    />
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Typography gutterBottom>希望エリア</Typography>
                <LocationSelector
                    value={{
                        prefecture: { name: data.profile.preferences.preferredAreas[0]?.prefecture || '' },
                        city: { name: data.profile.preferences.preferredAreas[0]?.city || '' },
                        line: { name: data.profile.preferences.preferredAreas[0]?.line || '' },
                        station: { name: data.profile.preferences.preferredAreas[0]?.station || '' }
                    }}
                    onChange={(locationData) => handleLocationChange(0, locationData)}
                    required={true}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel>居住希望期間</InputLabel>
                    <Select
                        value={data.profile.stayDuration}
                        onChange={(e) => handleChange('stayDuration', e.target.value)}
                        label="居住希望期間"
                    >
                        <MenuItem value="short">短期（1-3ヶ月）</MenuItem>
                        <MenuItem value="medium">中期（3-6ヶ月）</MenuItem>
                        <MenuItem value="long">長期（6ヶ月以上）</MenuItem>
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel>入居希望時期</InputLabel>
                    <Select
                        value={data.profile.moveInPreference}
                        onChange={(e) => handleChange('moveInPreference', e.target.value)}
                        label="入居希望時期"
                    >
                        <MenuItem value="within 1 month">1ヶ月以内</MenuItem>
                        <MenuItem value="within 3 months">3ヶ月以内</MenuItem>
                        <MenuItem value="within 6 months">6ヶ月以内</MenuItem>
                        <MenuItem value="more than 6 months">6ヶ月以上先</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
}

export default PreferencesForm; 